<!--
  AI:
  Status: 'in progress'
  Type: Component
  SubType: ObjectBaseComponent
  Reason: Root template of the read-only bank account overview OBC (cr.CustomerBankAccount, TM-1000002030).
          Branches by view mode only - the shape of cp-provision-type-matrix-object.component.html.

  The `initialized && dto` guard is mandatory: no dto exists before that. While the base class loads the
  object a skeleton stands in; a failed load is reported by the base class itself (toast „Objekt nicht
  gefunden …“, requirement §5.8). `handleNavigationItems($event)` passes the base view's navigation item
  through to the frame.

  'side' / 'mini-side' is the mode the Abrechnungs-Landkarte opens (right drawer, viewType 'overview'), so it
  is the branch that carries the day-to-day traffic.

  @ticket TM-1000002030
-->
<div class="cr-customer-bank-account-overview-object w-full">

    @if (initialized && dto) {

        @if (uiMode == 'side' || uiMode == 'mini-side') {

            <cr-customer-bank-account-overview-side
                    [objectIdentifier]="objectIdentifier"
                    [dto]="dto"
                    [uiMode]="uiMode"
                    (onNavigationItems)="handleNavigationItems($event)">
            </cr-customer-bank-account-overview-side>

        } @else {

            <cr-customer-bank-account-overview-full
                    [objectIdentifier]="objectIdentifier"
                    [dto]="dto"
                    [uiMode]="uiMode"
                    (onNavigationItems)="handleNavigationItems($event)">
            </cr-customer-bank-account-overview-full>

        }

    } @else if (busy) {

        <p-skeleton height="12rem"></p-skeleton>

    }

</div>
